import React, { useEffect, useState } from 'react';
import { HiOutlineUser, HiOutlineMail, HiOutlinePhone, HiOutlineOfficeBuilding, HiOutlineLocationMarker, HiOutlineCalendar, HiOutlineIdentification } from 'react-icons/hi';

export default function GuestFirmalarPage() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/guest-firmalar')
      .then(res => res.json())
      .then(setData)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex justify-center items-center h-40 text-blue-700 text-lg font-semibold animate-pulse">Yükleniyor...</div>;

  return (
    <div className="p-6 w-full">
      <h1 className="text-3xl font-bold mb-8 text-blue-900 flex items-center gap-3 px-6 pt-6">
        <HiOutlineOfficeBuilding className="w-8 h-8 text-blue-700" /> Misafir Firma Bilgileri
      </h1>
      <div className="overflow-x-auto rounded-2xl shadow-lg border border-blue-100 bg-white">
        <table className="min-w-full text-sm">
          <thead className="bg-blue-50">
            <tr>
              <th className="px-4 py-3 text-left font-semibold text-blue-900">Firma</th>
              <th className="px-4 py-3 text-left font-semibold text-blue-900">Yetkili</th>
              <th className="px-4 py-3 text-left font-semibold text-blue-900">İletişim</th>
              <th className="px-4 py-3 text-left font-semibold text-blue-900">Vergi</th>
              <th className="px-4 py-3 text-left font-semibold text-blue-900">Şehir</th>
              <th className="px-4 py-3 text-left font-semibold text-blue-900">Tarih</th>
            </tr>
          </thead>
          <tbody>
            {data.map(firma => (
              <tr key={firma.id} className="hover:bg-blue-50 transition">
                <td className="px-4 py-3 flex items-center gap-3">
                  <span className="w-9 h-9 rounded-full bg-blue-100 flex items-center justify-center text-blue-700 text-lg font-bold mr-2">
                    <HiOutlineOfficeBuilding className="w-5 h-5" />
                  </span>
                  <span className="font-bold text-blue-900">{firma.firma}</span>
                </td>
                <td className="px-4 py-3">
                  <span className="flex items-center gap-1 text-blue-800"><HiOutlineUser className="w-4 h-4" /> {firma.yetkili}</span>
                </td>
                <td className="px-4 py-3">
                  <span className="flex items-center gap-1 text-blue-800"><HiOutlinePhone className="w-4 h-4" /> {firma.telefon}</span><br/>
                  <span className="flex items-center gap-1 text-blue-800"><HiOutlineMail className="w-4 h-4" /> {firma.email}</span>
                </td>
                <td className="px-4 py-3">
                  <span className="flex items-center gap-1 text-blue-800"><HiOutlineIdentification className="w-4 h-4" /> {firma.vergiDairesi}</span><br/>
                  <span className="flex items-center gap-1 text-blue-800">{firma.vergiNo}</span>
                </td>
                <td className="px-4 py-3 text-blue-800">{firma.sehir}</td>
                <td className="px-4 py-3 text-blue-800"><span className="flex items-center gap-1"><HiOutlineCalendar className="w-4 h-4" /> {new Date(firma.created_at).toLocaleDateString()}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
} 